import {
  RunFlatToggle,
  TireTypePicker,
  Title,
  TireLocationPicker,
  TireSizeSelector,
  WarningModal,
} from '@/components';

import validationFlow from '@/validation-flow';

import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  name: 'step5TireInfoMobileTTP',
  components: {
    [RunFlatToggle.name]: RunFlatToggle,
    [TireTypePicker.name]: TireTypePicker,
    [Title.name]: Title,
    [TireLocationPicker.name]: TireLocationPicker,
    [TireSizeSelector.name]: TireSizeSelector,
    [WarningModal.name]: WarningModal,
  },
  props: {},
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      tireType: 'getTireType',
      tireLocations: 'getTireLocations',
      bodyworkType: 'getBodyworkType',
      tireSizes: 'getTireSizes',
      serviceType: 'getServiceType',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
      tireCodes: 'getTireCodes',
    }),
    isValidTireInfo() {
      // Check als ze 4 banden hebben volgens tiretype & cartype
      let stockOrActive = 0;
      const tireLocations = ['t1l1', 't1r1', 't2l2', 't2l1', 't2r1', 't2r2'];

      tireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 || stockState === 3) {
          stockOrActive += 1;
        }
      });

      let correctAmountOfTires = (this.bodyworkType === 'car' && stockOrActive === 4) ||
        (this.bodyworkType === 'bus' && stockOrActive === 6);

      // Bij nieuwe banden moet de stock niet /4 of /6 zijn
      if (this.serviceType === 'new-tires' && stockOrActive > 0) {
        correctAmountOfTires = true;
      }

      // Check size on ax where there is an active tire
      const frontAxisTireLocations = ['t1l1', 't1r1'];
      const backAxisTireLocations = ['t2l2', 't2l1', 't2r1', 't2r2'];

      let hasFrontAxisTire = false;
      let hasBackAxisTire = false;

      frontAxisTireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 && stockState !== 1) {
          hasFrontAxisTire = true;
        }
      });

      backAxisTireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 && stockState !== 1) {
          hasBackAxisTire = true;
        }
      });

      const properties = ['width', 'height', 'diameter', 'loadCapacity', 'speedIndex'];
      let correctFrontSizes = true;
      let correctBackSizes = true;

      if (hasFrontAxisTire) {
        properties.forEach(property => {
          if (this.tireSizes.frontTire[property] === 0 ||
            this.tireSizes.frontTire[property] === '') {
              correctFrontSizes = false;
          }
        });
      }

      if (hasBackAxisTire) {
        properties.forEach(property => {
          if (this.tireSizes.backTire[property] === 0 ||
            this.tireSizes.backTire[property] === '') {
              correctBackSizes = false;
          }
        });
      }

      return correctAmountOfTires && correctFrontSizes && correctBackSizes;
    },
  },
  methods: {
    goToPreviousStep() {
      this.$router.push({
        name: 'step3ServiceType',
      });
    },
    makeAppointment() {
      if (this.isValidTireInfo) {
        validationFlow.validateStep5TireInfoMobileTPP();
      }
    },
    ...mapActions('garage', {
      getGarages: 'FETCH_DATA_GARAGES',
      getTireCodes: 'FETCH_DATA_TIRECODES',
    }),
  },
  created() {
    if (this.garages.length === 0) {
      this.getGarages();
    }
    if (this.tireCodes.length === 0) {
      this.getTireCodes();
    }
  },
};
